import _ from "underscore";
import Grid from "@material-ui/core/Grid";
import I18n from "../components/locale/I18n.js";
import { makeStyles } from "@material-ui/styles";
import React from "react";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    root(props) {
        return {
            backgroundColor: props.backgroundColor
        };
    },
    subtitle: {
        marginTop: "10px",
        lineHeight: 1.5,
        color: "#777"
    },
    textContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    text: {
        padding: "30px 0 0 0"
    },
    buttons: {
        marginTop: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start"
    }
}));

const Hero = props => {
    const { actions, image, subtitle, title } = props;
    const classes = useStyles(props);
    return (
        <div style={{ overflow: "hidden" }}>
            <Grid container spacing={3}>
                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    className={classes.textContent}
                >
                    <div>
                        <div className={classes.text}>
                            <Typography variant="h4">{title}</Typography>
                            <Typography
                                variant="subtitle1"
                                className={classes.subtitle}
                            >
                                {subtitle}
                            </Typography>
                        </div>
                        <div className={classes.buttons}>
                            {_.map(actions, (action, index) => (
                                <div className={classes.button} key={index}>
                                    {action}
                                </div>
                            ))}
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    {image}
                </Grid>
            </Grid>
        </div>
    );
};

export default Hero;
